import { render, staticRenderFns } from "./EscalationIntermediateCatchEvent.vue?vue&type=template&id=1da4e484&scoped=true&"
import script from "./EscalationIntermediateCatchEvent.vue?vue&type=script&lang=js&"
export * from "./EscalationIntermediateCatchEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da4e484",
  null
  
)

export default component.exports